import { MAX_DECIMALES_CANTIDAD } from './constants-ejb';

/**
 * Cantidad de negocio a 2 decimales (half up), la misma escala del saldo por
 * programar. 20 minutos como horas (20/60) es 0.3333333333333333 y el SP la
 * rechaza contra un saldo de 0.33.
 */
export function redondearCantidad(valor: number): number {
  if (!Number.isFinite(valor)) {
    return valor;
  }
  return Number(valor.toFixed(MAX_DECIMALES_CANTIDAD));
}
